import { type CoreItemCategory } from '@flecto/types'
import { DataTable, type DataTableProps } from '@flecto/ui'

import { useModalCategoryUpdate } from '../../../categories'
import styles from './styles.module.css'
import { useColumns } from './useColumns'

type TableCategoriesProps = Omit<
  DataTableProps<CoreItemCategory>,
  'columns'
> & {
  isLoading?: boolean
  items?: CoreItemCategory[]
  setCategories?: (category: CoreItemCategory) => void
}

export function TableCategories({
  isLoading,
  items,
  ...props
}: TableCategoriesProps) {
  const columns = useColumns()
  const { openModal } = useModalCategoryUpdate()

  return (
    <DataTable
      className={styles.table}
      columns={columns}
      highlightOnHover
      isLoading={isLoading}
      onRowClick={({ record }) => openModal({ category: record })}
      records={items}
      rowBackgroundColor={({ parent_id }) => (parent_id ? 'gray.0' : undefined)}
      withPagination={false}
      {...props}
    />
  )
}
